import React from "react";

const STATUS = {
  activo: { label: "Activo", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500" },
  retirado: { label: "Retirado", cls: "bg-zinc-100 text-zinc-600 border-zinc-200", dot: "bg-zinc-400" },
};

const ORIGEN = {
  roge: { label: "Roge", cls: "bg-vino-100 text-vino-800 border-vino-200" },
  carga_inicial: { label: "Carga inicial", cls: "bg-amber-50 text-amber-700 border-amber-200" },
};

export function EstadoBadge({ estado, testid }) {
  const s = STATUS[estado] || STATUS.activo;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${s.cls}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
}

export function OrigenBadge({ origen, testid }) {
  const o = ORIGEN[origen] || ORIGEN.roge;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${o.cls}`}
    >
      {o.label}
    </span>
  );
}

export function AutosaveNote({ auto, testid = "autosave-status" }) {
  return (
    <span data-testid={testid} className={`text-xs ${auto === "error" ? "text-amber-600" : "text-slate-400"}`}>
      {auto === "guardando"
        ? "Guardando cambios…"
        : auto === "error"
          ? "No se pudo autoguardar; se reintentará en 30 s"
          : auto
            ? `Autoguardado a las ${auto}`
            : "Autoguardado cada 30 s"}
    </span>
  );
}

export function Spinner({ className = "" }) {
  return (
    <span
      className={`inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent ${className}`}
    />
  );
}

export function Empty({ icon: Icon, title, subtitle, children }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-slate-200 bg-white px-6 py-16 text-center">
      {Icon && (
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-vino-50 text-vino-700">
          <Icon className="h-7 w-7" />
        </div>
      )}
      <h3 className="text-base font-semibold text-slate-800">{title}</h3>
      {subtitle && <p className="mt-1 max-w-md text-sm text-slate-500">{subtitle}</p>}
      {children && <div className="mt-5">{children}</div>}
    </div>
  );
}
